// Whether the current account's role allows an action (lib/roles.ts).
//
// A module of its own, built on useAuth, rather than part of AuthContext: it
// reads the role off the tenant, so it works wherever useAuth does, including
// under a test that stubs useAuth alone.

import { useAuth } from "./AuthContext";
import { can, type Action } from "../lib/roles";

export function useCan(): (action: Action) => boolean {
  const { tenant } = useAuth();
  return (action) => can(tenant?.role, action);
}
